export default __webpack_public_path__ + "assets/models/886eb4f6d32f1ce489f0f929e5a98626.glb";